/* PURCHASE REQUEST */
export const PR_DRAFT_PAGE                    = 'PR_DRAFT_PAGE'
export const PR_DRAFT_CURRENTPAGE             = 'PR_DRAFT_CURRENTPAGE'
export const PR_REQUEST_PAGE                  = 'PR_REQUEST_PAGE'
export const PR_REQUEST_CURRENTPAGE           = 'PR_REQUEST_CURRENTPAGE'
export const PR_PAGE                          = 'PR_PAGE'
export const PR_CURRENTPAGE                   = 'PR_CURRENTPAGE'
/* PURCHASE ORDER */
export const PO_MY_ORDERS_PAGE                = 'PO_MY_ORDERS_PAGE'
export const PO_MY_ORDERS_CURRENTPAGE         = 'PO_MY_ORDERS_CURRENTPAGE'
export const PO_PAGE                          = 'PO_PAGE'
export const PO_CURRENTPAGE                   = 'PO_CURRENTPAGE'
/* MATERIAL HISTORY */
export const MH_PAGE                          = 'MH_PAGE'
export const MH_CURRENTPAGE                   = 'MH_CURRENTPAGE'
export const MATERIAL_HISTORIES               = 'MATERIAL_HISTORIES'
export const MH_LOADING                       = 'MH_LOADING'
export const MH_SEARCH                        = 'MH_SEARCH'
export const MH_STORLOC                       = 'MH_STORLOC'
export const MH_TIME                          = 'MH_TIME'
export const MH_DATEFROM                      = 'MH_DATEFROM'
export const MH_DATETO                        = 'MH_DATETO'
export const MH_DOCTYPE                       = 'MH_DOCTYPE'
export const MH_TRANSACTION                   = 'MH_TRANSACTION'
/* MATERIAL OFFTAKE */
export const MO_CLEAR                         = 'MO_CLEAR'
export const MO_LOADING                       = 'MO_LOADING'
export const MO_PAGE                          = 'MO_PAGE'
export const MO_CURRENTPAGE                   = 'MO_CURRENTPAGE'
export const MO_DATA                          = 'MO_DATA'
export const MO_MATERIALGROUPS                = 'MO_MATERIALGROUPS'
export const MO_MATERIALGROUP1                = 'MO_MATERIALGROUP1'
export const MO_MATERIALGROUP3                = 'MO_MATERIALGROUP3'
export const MO_MATERIALGROUP5                = 'MO_MATERIALGROUP5'
export const MO_DATERANGESELECTED                = 'MO_DATERANGESELECTED'
export const MO_MATERIALS                     = 'MO_MATERIALS'
export const MO_MATERIALFROM                  = 'MO_MATERIALFROM'
export const MO_MATERIALTO                    = 'MO_MATERIALTO'
export const MO_VENDORFROM                    = 'MO_VENDORFROM'
export const MO_VENDORTO                      = 'MO_VENDORTO'
export const MO_MATERIALGROUPFROM             = 'MO_MATERIALGROUPFROM'
export const MO_MATERIALGROUPTO               = 'MO_MATERIALGROUPTO'
export const MO_MATERIALGROUP1FROM            = 'MO_MATERIALGROUP1FROM'
export const MO_MATERIALGROUP1TO              = 'MO_MATERIALGROUP1TO'
export const MO_MATERIALGROUP3FROM            = 'MO_MATERIALGROUP3FROM'
export const MO_MATERIALGROUP3TO              = 'MO_MATERIALGROUP3TO'
export const MO_MATERIALGROUP5FROM            = 'MO_MATERIALGROUP5FROM'
export const MO_MATERIALGROUP5TO              = 'MO_MATERIALGROUP5TO'
export const MO_RANGESHOW                     = 'MO_RANGESHOW'
export const MO_SPECIFICSHOW                  = 'MO_SPECIFICSHOW'
/* MATERIAL OFFTAKE SEARCH */
export const MOS_CLEAR                        = 'MOS_CLEAR'
export const MOS_LOADING                      = 'MOS_LOADING'
export const MOS_PAGE                         = 'MOS_PAGE'
export const MOS_CURRENTPAGE                  = 'MOS_CURRENTPAGE'
export const MOS_SEARCH                       = 'MOS_SEARCH'
export const MOS_DATA                         = 'MOS_DATA'
export const MOS_MATERIALS                    = 'MOS_MATERIALS'
/* FOR RELEASE */
export const REL_ID                           = 'REL_ID'
export const REL_PAGE                         = 'REL_PAGE'
export const REL_CURRENTPAGE                  = 'REL_CURRENTPAGE'
export const REL_LOADING                      = 'REL_LOADING'
export const REL_SEARCH                       = 'REL_SEARCH'
export const REL_COMPANY                      = 'REL_COMPANY'
export const REL_STATUS                       = 'REL_STATUS'
export const REL_SUPPLIER_FROM                = 'REL_SUPPLIER_FROM'
export const REL_SUPPLIER_TO                  = 'REL_SUPPLIER_TO'
export const REL_USER                         = 'REL_USER'
export const REL_DATE_FROM                    = 'REL_DATE_FROM'
export const REL_DATE_TO                      = 'REL_DATE_TO'
export const REL_MATERIAL                     = 'REL_MATERIAL'
export const REL_DATA                         = 'REL_DATA'
export const REL_DETAILS                      = 'REL_DETAILS'
export const REL_DISCOUNT                     = 'REL_DISCOUNT'
export const REL_DISCOUNT_DETAILS             = 'REL_DISCOUNT_DETAILS'
export const REL_DISCOUNT_LOADING             = 'REL_DISCOUNT_LOADING'       
export const REL_ADD_DISCOUNT                 = 'REL_ADD_DISCOUNT'
export const REL_DEL_DISCOUNT                 = 'REL_DEL_DISCOUNT'
export const REL_EDIT_DISCOUNT                = 'REL_EDIT_DISCOUNT'
export const REL_ERR_DISCOUNT                 = 'REL_ERR_DISCOUNT'
export const REL_HISTORY                      = 'REL_HISTORY'
export const REL_HISTORY_DATA                 = 'REL_HISTORY_DATA'
export const REL_HISTORY_LOADING              = 'REL_HISTORY_LOADING'
export const REL_HISTORY_ERR                  = 'REL_HISTORY_ERR'
export const REL_HISTORY_ERR_DATA             = 'REL_HISTORY_ERR_DATA'
export const REL_HISTORY_ERR_LOADING          = 'REL_HISTORY_ERR_LOADING'
export const REL_UPDATE_DETAILS               = 'REL_UPDATE_DETAILS'
export const REL_PO_UPDATE                    = 'REL_PO_UPDATE'
export const REL_UPDATE_RETURN                = 'REL_UPDATE_RETURN'
export const REL_RETURN                       = 'REL_RETURN'
export const REL_PRINT_PO                     = 'REL_PRINT_PO'
export const REL_PRINT_PO_DATA                = 'REL_PRINT_PO_DATA'
/* FOR RELEASE DETAILS */
export const REL_DET_ID                       = 'REL_DET_ID'
export const REL_DET_PAGE                     = 'REL_DET_PAGE'
export const REL_DET_CURRENTPAGE              = 'REL_DET_CURRENTPAGE'
export const REL_DET_LOADING                  = 'REL_DET_LOADING'
export const REL_DET_SEARCH                   = 'REL_DET_SEARCH'
export const REL_DET_DATA                     = 'REL_DET_DATA'
export const REL_DET_COMPANY                  = 'REL_DET_COMPANY'
export const REL_DET_STORLOC                  = 'REL_DET_STORLOC'
export const REL_DET_ERROR                    = 'REL_DET_ERROR'
export const REL_DET_OFFTAKE                  = 'REL_DET_OFFTAKE'
export const REL_DET_LASTMONTH                = 'REL_DET_LASTMONTH'
export const REL_DET_ONORDER                  = 'REL_DET_ONORDER'
export const REL_DET_INVENTORY                = 'REL_DET_INVENTORY'
export const REL_DET_MATNR                    = 'REL_DET_MATNR'
export const REL_DET_MAT_LOADING              = 'REL_DET_MAT_LOADING'
export const REL_DET_OFFTAKEDATA              = 'REL_DET_OFFTAKEDATA'
export const REL_DET_LASTMONTHDATA            = 'REL_DET_LASTMONTHDATA'
export const REL_DET_INVENTORYDATA            = 'REL_DET_INVENTORYDATA'
export const REL_DET_ONORDERDATA              = 'REL_DET_ONORDERDATA'
export const REL_DET_UPDATE_DETAILS           = 'REL_DET_UPDATE_DETAILS'
export const REL_DET_UPDATE_ID                = 'REL_DET_UPDATE_ID'
export const REL_DET_UPDATE_RETURN            = 'REL_DET_UPDATE_RETURN'
export const REL_DET_DISCOUNT                 = 'REL_DET_DISCOUNT'
export const REL_DET_DISCOUNT_DETAILS         = 'REL_DET_DISCOUNT_DETAILS'
export const REL_DET_DISCOUNT_LOADING         = 'REL_DET_DISCOUNT_LOADING'
export const REL_DET_ITEM_ID                  = 'REL_DET_ITEM_ID'
export const REL_DET_ADD_DISCOUNT             = 'REL_DET_ADD_DISCOUNT'
export const REL_DET_DEL_DISCOUNT             = 'REL_DET_DEL_DISCOUNT'
export const REL_DET_EDIT_DISCOUNT            = 'REL_DET_EDIT_DISCOUNT'
export const REL_DET_ERR_DISCOUNT             = 'REL_DET_ERR_DISCOUNT'
export const REL_DET_UPDATE_DISCOUNTS         = 'REL_DET_UPDATE_DISCOUNTS'
export const REL_DET_ADD_ITEM                 = 'REL_DET_ADD_ITEM'
export const REL_DET_ADD_ITEM_PAGE            = 'REL_DET_ADD_ITEM_PAGE'
export const REL_DET_ADD_ITEM_CURRENTPAGE     = 'REL_DET_ADD_ITEM_CURRENTPAGE'
export const REL_DET_ADD_ITEM_LOADING         = 'REL_DET_ADD_ITEM_LOADING'
export const REL_DET_ADD_ITEM_SEARCH          = 'REL_DET_ADD_ITEM_SEARCH'
export const REL_DET_ADD_ITEM_DATA            = 'REL_DET_ADD_ITEM_DATA'
export const REL_DET_ADD_ITEM_FORM_DATA       = 'REL_DET_ADD_ITEM_FORM_DATA'
export const REL_DET_ADD_ITEMS                = 'REL_DET_ADD_ITEMS'
export const REL_DET_ADD_ITEM_ERROR           = 'REL_DET_ADD_ITEM_ERROR'

/* MATERIAL MASTER */
export const MAT_MAS_DATA = 'MAT_MAS_DATA'
export const MAT_MAS_PAGE = 'MAT_MAS_PAGE'
export const MAT_MAS_COMPANY = 'MAT_MAS_COMPANY'
export const MAT_MAS_CURRENTPAGE = 'MAT_MAS_CURRENTPAGE'
export const MAT_MAS_SEARCH = 'MAT_MAS_SEARCH'
export const MAT_MAS_LOADING = 'MAT_MAS_LOADING'
export const MAT_MAS_MATS_MODAL = 'MAT_MAS_MATS_MODAL'
export const MAT_MAS_MAT_RANGE_MODAL = 'MAT_MAS_MAT_RANGE_MODAL'
export const MAT_MAS_MGFROM = 'MAT_MAS_MGFROM'
export const MAT_MAS_MGTO = 'MAT_MAS_MGTO'
export const MAT_MAS_MG1FROM = 'MAT_MAS_MG1FROM'
export const MAT_MAS_MG1TO = 'MAT_MAS_MG1TO'
export const MAT_MAS_MG2FROM = 'MAT_MAS_MG2FROM'
export const MAT_MAS_MG2TO = 'MAT_MAS_MG2TO'
export const MAT_MAS_MG3FROM = 'MAT_MAS_MG3FROM'
export const MAT_MAS_MG3TO = 'MAT_MAS_MG3TO'
export const MAT_MAS_MG4FROM = 'MAT_MAS_MG4FROM'
export const MAT_MAS_MG4TO = 'MAT_MAS_MG4TO'
export const MAT_MAS_MG5FROM = 'MAT_MAS_MG5FROM'
export const MAT_MAS_MG5TO = 'MAT_MAS_MG5TO'
export const MAT_MAS_PHFROM = 'MAT_MAS_PHFROM'
export const MAT_MAS_PHTO = 'MAT_MAS_PHTO'
export const MAT_MAS_MATS = 'MAT_MAS_MATS'
export const MAT_MAS_MATFROM = 'MAT_MAS_MATFROM'
export const MAT_MAS_MATTO = 'MAT_MAS_MATTO'


/* PURCHASE RETURN CREATE */
export const PRET_DATA = 'PRET_DATA'
export const PRET_RESET_DATA = 'PRET_RESET_DATA'
export const PRET_SHOW_MULT_SEARCH_MODAL = 'PRET_SHOW_MULT_SEARCH_MODAL'
export const PRET_MULT_SEARCH_ITEMS = 'PRET_MULT_SEARCH_ITEMS'
export const PRET_RETURN = 'PRET_RETURN'
export const PRET_STORLOC = 'PRET_STORLOC'
export const PRET_COMPCODE = 'PRET_COMPCODE'

/* PURCHASE RETURNS */
export const PURCHASE_RETURN_DATA = 'PURCHASE_RETURN_DATA'
export const PURCHASE_RETURN_PAGE = 'PURCHASE_RETURN_PAGE'
export const PURCHASE_RETURN_CURRENTPAGE = 'PURCHASE_RETURN_CURRENTPAGE'
export const PURCHASE_RETURN_LOADING = 'PURCHASE_RETURN_LOADING'
export const PURCHASE_RETURN_SEARCH = 'PURCHASE_RETURN_SEARCH'
export const PURCHASE_RETURN_COMPANY = 'PURCHASE_RETURN_COMPANY'
export const PURCHASE_RETURN_SUPPLIER_FROM = 'PURCHASE_RETURN_SUPPLIER_FROM'
export const PURCHASE_RETURN_SUPPLIER_TO = 'PURCHASE_RETURN_SUPPLIER_TO'
export const PURCHASE_RETURN_DATE_FROM = 'PURCHASE_RETURN_DATE_FROM'
export const PURCHASE_RETURN_DATE_TO = 'PURCHASE_RETURN_DATE_TO'
export const PURCHASE_RETURN_STATUS = 'PURCHASE_RETURN_STATUS'
export const PURCHASE_RETURN_PARTIAL_STATUS = 'PURCHASE_RETURN_PARTIAL_STATUS'
export const PURCHASE_RETURN_ADDED_BY = 'PURCHASE_RETURN_ADDED_BY'
export const PURCHASE_RETURN_MATNR = 'PURCHASE_RETURN_MATNR'

/* PURCHASE RETURN */
export const PURCHASE_RETURN_DETAILS_ID = 'PURCHASE_RETURN_DETAILS_ID'
export const PURCHASE_RETURN_DETAILS_HEADER = 'PURCHASE_RETURN_DETAILS_HEADER'
export const PURCHASE_RETURN_DETAILS_PAGE = 'PURCHASE_RETURN_DETAILS_PAGE'
export const PURCHASE_RETURN_DETAILS_CURRENTPAGE = 'PURCHASE_RETURN_DETAILS_CURRENTPAGE'
export const PURCHASE_RETURN_DETAILS_SEARCH = 'PURCHASE_RETURN_DETAILS_SEARCH'
export const PURCHASE_RETURN_DETAILS_LOADING = 'PURCHASE_RETURN_DETAILS_LOADING'
export const PURCHASE_RETURN_DETAILS_ITEMS = 'PURCHASE_RETURN_DETAILS_ITEMS'
export const PURCHASE_RETURN_DETAILS_ADD_ITEM = 'PURCHASE_RETURN_DETAILS_ADD_ITEM'
export const PURCHASE_RETURN_DETAILS_ADDED_ITEMS = 'PURCHASE_RETURN_DETAILS_ADDED_ITEMS'
export const PURCHASE_RETURN_DETAILS_UPDATE_ITEM = 'PURCHASE_RETURN_DETAILS_UPDATE_ITEM'
export const PURCHASE_RETURN_DETAILS_UPDATE_HEADER = 'PURCHASE_RETURN_DETAILS_UPDATE_HEADER'
export const PURCHASE_RETURN_DETAILS_RETURN = 'PURCHASE_RETURN_DETAILS_RETURN'

export const PURCHASE_RETURN_DETAILS_HISTORY = 'PURCHASE_RETURN_DETAILS_HISTORY'
export const PURCHASE_RETURN_DETAILS_HISTORY_DATA = 'PURCHASE_RETURN_DETAILS_HISTORY_DATA'

/* PURCHASE RETURN DRAFTS */
export const PURCHASE_RETURN_DRAFT_PAGE = 'PURCHASE_RETURN_DRAFT_PAGE'
export const PURCHASE_RETURN_DRAFT_CURRENTPAGE = 'PURCHASE_RETURN_DRAFT_CURRENTPAGE'
export const PURCHASE_RETURN_DRAFT_SEARCH = 'PURCHASE_RETURN_DRAFT_SEARCH'
export const PURCHASE_RETURN_DRAFT_LOADING = 'PURCHASE_RETURN_DRAFT_LOADING'
export const PURCHASE_RETURN_DRAFT_MATNR = 'PURCHASE_RETURN_DRAFT_MATNR'
export const PURCHASE_RETURN_DRAFT_DATE_FROM = 'PURCHASE_RETURN_DRAFT_DATE_FROM'
export const PURCHASE_RETURN_DRAFT_DATE_TO = 'PURCHASE_RETURN_DRAFT_DATE_TO'
export const PURCHASE_RETURN_DRAFT_DATA = 'PURCHASE_RETURN_DRAFT_DATA'

/* PURCHASE RETURN DRAFT DETAILS */
export const PURCHASE_RETURN_DRAFT_DETAILS_ID = 'PURCHASE_RETURN_DRAFT_DETAILS_ID'
export const PURCHASE_RETURN_DRAFT_DETAILS_HEADER = 'PURCHASE_RETURN_DRAFT_DETAILS_HEADER'
export const PURCHASE_RETURN_DRAFT_DETAILS_PAGE = 'PURCHASE_RETURN_DRAFT_DETAILS_PAGE'
export const PURCHASE_RETURN_DRAFT_DETAILS_CURRENTPAGE = 'PURCHASE_RETURN_DRAFT_DETAILS_CURRENTPAGE'
export const PURCHASE_RETURN_DRAFT_DETAILS_SEARCH = 'PURCHASE_RETURN_DRAFT_DETAILS_SEARCH'
export const PURCHASE_RETURN_DRAFT_DETAILS_LOADING = 'PURCHASE_RETURN_DRAFT_DETAILS_LOADING'
export const PURCHASE_RETURN_DRAFT_DETAILS_DATA = 'PURCHASE_RETURN_DRAFT_DETAILS_DATA'
export const PURCHASE_RETURN_DRAFT_DETAILS_ADD_ITEM = 'PURCHASE_RETURN_DRAFT_DETAILS_ADD_ITEM'
export const PURCHASE_RETURN_DRAFT_DETAILS_ADDED_ITEMS = 'PURCHASE_RETURN_DRAFT_DETAILS_ADDED_ITEMS'
export const PURCHASE_RETURN_DRAFT_DETAILS_UPDATE_ITEM = 'PURCHASE_RETURN_DRAFT_DETAILS_UPDATE_ITEM'
export const PURCHASE_RETURN_DRAFT_DETAILS_RETURN = 'PURCHASE_RETURN_DRAFT_DETAILS_RETURN'
export const PURCHASE_RETURN_DRAFT_DETAILS_ADD_ITEM_RETURN = 'PURCHASE_RETURN_DRAFT_DETAILS_ADD_ITEM_RETURN'

/* APPROVED PURCHASE RETURN */
export const APP_PURCHASE_RETURN_DATA = 'APP_PURCHASE_RETURN_DATA'
export const APP_PURCHASE_RETURN_PAGE = 'APP_PURCHASE_RETURN_PAGE'
export const APP_PURCHASE_RETURN_CURRENTPAGE = 'APP_PURCHASE_RETURN_CURRENTPAGE'
export const APP_PURCHASE_RETURN_LOADING = 'APP_PURCHASE_RETURN_LOADING'
export const APP_PURCHASE_RETURN_SEARCH = 'APP_PURCHASE_RETURN_SEARCH'
export const APP_PURCHASE_RETURN_COMPANY = 'APP_PURCHASE_RETURN_COMPANY'
export const APP_PURCHASE_RETURN_SUPPLIER_FROM = 'APP_PURCHASE_RETURN_SUPPLIER_FROM'
export const APP_PURCHASE_RETURN_SUPPLIER_TO = 'APP_PURCHASE_RETURN_SUPPLIER_TO'
export const APP_PURCHASE_RETURN_DATE_FROM = 'APP_PURCHASE_RETURN_DATE_FROM'
export const APP_PURCHASE_RETURN_DATE_TO = 'APP_PURCHASE_RETURN_DATE_TO'
export const APP_PURCHASE_RETURN_MATERIAL = 'APP_PURCHASE_RETURN_MATERIAL'
export const APP_PURCHASE_RETURN_USER = 'APP_PURCHASE_RETURN_USER'
export const APP_PURCHASE_RETURN_STATUS = 'APP_PURCHASE_RETURN_STATUS'
// 11/19/2021 start
export const APP_PURCHASE_RETURN_PRINT = 'APP_PURCHASE_RETURN_PRINT'
export const APP_PURCHASE_RETURN_PRINT_DATA = 'APP_PURCHASE_RETURN_PRINT_DATA'
// end